import { render, staticRenderFns } from "./PanelForm.vue?vue&type=template&id=f2fafc96&"
import script from "./PanelForm.vue?vue&type=script&lang=js&"
export * from "./PanelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2fafc96')) {
      api.createRecord('f2fafc96', component.options)
    } else {
      api.reload('f2fafc96', component.options)
    }
    module.hot.accept("./PanelForm.vue?vue&type=template&id=f2fafc96&", function () {
      api.rerender('f2fafc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/panel/PanelForm.vue"
export default component.exports